import { Env, Hosts } from './env.type';

export const defaultHosts: Hosts = {
  vsAdminApp: 'https://admin.cloud.viewsonic.com',
  vsApp: 'https://cloud.viewsonic.com',
  vsApi: 'https://api.cloud.viewsonic.com',
  vsSsoApi: 'https://api.viewsonic.cloud',
  vsAsset: 'https://assets.cloud.viewsonic.com',
};

export const env: (opts: { hosts: Hosts }) => Env = ({ hosts }) => ({
  deployEnv: 'prod',
  apiEndpoint: {
    mvb: 'https://api.myviewboard.com',
    vs: hosts.vsApi,
    dmAdmin: 'https://api.myviewboard.com/api/dm/admin-portal/v2/cms/graphql',
    vsSubscription: `${hosts.vsApi}/subscription/graphql/v1/subscription`,
    vsAuth: hosts.vsApp,
    vsSso: hosts.vsSsoApi,
    vsAdminAuth: hosts.vsAdminApp,
  },
  oidcAuthority: {
    vs: `${hosts.vsApp}/auth/v1/oidc`,
    vsAdmin: `${hosts.vsAdminApp}/auth/v1/oidc`,
  },
  appUrl: {
    legalDoc: `${hosts.vsApp}/legal`,
    accountPortal: `${hosts.vsApp}/account`,
    entityPortal: `${hosts.vsApp}/entity`,
  },
  applicationInsightsInstrumentationKey: {
    mvb: '24ce024d-7d9b-408c-929f-253d7a6bb1b4',
  },
  assets: {
    vs: `${hosts.vsAsset}`,
  },
  product: {
    mvb: 'https://myviewboard.com/preview',
    dm: 'https://myviewboard.com/mydashboard/dm',
    classSwift: 'https://www.classswift.viewsonic.io/',
    teamone: 'https://teamone.viewsonic.com/dashboard',
    originals: 'https://myviewboard.com/originals',
  },
  downloads: {
    nfcConnectorInstaller:
      'https://store2.myviewboard.com/uploads/launcher-nfc/NFC-ConnectorInstaller_1.0.4.exe',
  },
});
